module.exports = __webpack_public_path__ + "img/yellowCheck.bf9e7c5f.svg";